import React, { Component } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import Constant from "./Constant";
import "../css/style.css";
import { getAccessToken } from "../hooks/AccessToken";

class ExpertDashboard extends Component {
  state = {
    loading: true,
    totalUsers: 0,
    usersLast30Days: 0,
    totalStories: 0,
    storiesLast30Days: 0,
    totalPoetries: 0,
    poetriesLast30Days: 0,
  };

  componentDidMount() {
    this.fetchDashboardData();
  }

  fetchDashboardData() {
    const token = getAccessToken();
    Axios({
      method: "GET",
      url: Constant.apiBasePath + "dashboard",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        token: token,
      },
    })
      .then((response) => {
        const { data } = response;
        if (data.status === Constant.statusSuccess) {
          const d = data.data;
          this.setState({
            loading: false,
            totalUsers: d.totalUsers || 0,
            usersLast30Days: d.usersLast30Days || 0,
            totalStories: d.totalStories || 0,
            storiesLast30Days: d.storiesLast30Days || 0,
            totalPoetries: d.totalPoetries || 0,
            poetriesLast30Days: d.poetriesLast30Days || 0,
          });
        } else {
          alert(data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.error("Dashboard fetch error:", error);
        this.setState({ loading: false });
      });
  }

  render() {
    const {
      loading,
      totalUsers,
      usersLast30Days,
      totalStories,
      storiesLast30Days,
      totalPoetries,
      poetriesLast30Days,
    } = this.state;

    const cards = [
      {
        icon: "fa fa-users",
        iconBg: "#4e73df",
        label: "Total Users",
        value: totalUsers,
        sub: null,
        link: "/user-management",
        linkLabel: "View Users",
      },
      {
        icon: "fa fa-user-plus",
        iconBg: "#1cc88a",
        label: "New Users",
        value: usersLast30Days,
        sub: "Last 30 days",
        link: "/user-management",
        linkLabel: "View Users",
      },
      {
        icon: "fa fa-book",
        iconBg: "#f6c23e",
        label: "Total Stories",
        value: totalStories,
        sub: null,
        link: "/story-management",
        linkLabel: "View Stories",
      },
      {
        icon: "fa fa-bookmark",
        iconBg: "#e67e22",
        label: "New Stories",
        value: storiesLast30Days,
        sub: "Last 30 days",
        link: "/story-management",
        linkLabel: "View Stories",
      },
      {
        icon: "fa fa-pencil",
        iconBg: "#9b59b6",
        label: "Total Poetries",
        value: totalPoetries,
        sub: null,
        link: "/poem-management",
        linkLabel: "View Poetries",
      },
      {
        icon: "fa fa-pencil-square-o",
        iconBg: "#e74a3b",
        label: "New Poetries",
        value: poetriesLast30Days,
        sub: "Last 30 days",
        link: "/poem-management",
        linkLabel: "View Poetries",
      },
    ];

    return (
      <div className="content-page">
        <div className="content dashboardPage">
          <div className="row mb-3">
            <div className="col-12">
              <h4 className="page-title-heading">Dashboard</h4>
            </div>
          </div>

          {loading ? (
            <div className="row">
              <div className="col-12 text-center py-5">
                <i className="fa fa-spinner fa-spin fa-2x text-muted"></i>
                <p className="mt-2 text-muted">Loading stats…</p>
              </div>
            </div>
          ) : (
            <div className="row">
              {cards.map((card, idx) => (
                <div className="col-xl-4 col-lg-6 col-md-6 mb-4" key={idx}>
                  <div
                    className="card h-100"
                    style={{
                      borderRadius: "12px",
                      boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                      border: "none",
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ height: "6px", background: card.iconBg }} />
                    <div
                      className="card-body d-flex flex-column justify-content-between"
                      style={{ padding: "24px" }}
                    >
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div>
                          <p
                            className="text-uppercase font-weight-bold mb-1"
                            style={{
                              fontSize: "11px",
                              letterSpacing: "1px",
                              color: "#8a8d93",
                            }}
                          >
                            {card.label}
                          </p>
                          <h2
                            className="mb-0"
                            style={{
                              fontSize: "36px",
                              fontWeight: "700",
                              color: "#2d3748",
                            }}
                          >
                            {card.value.toLocaleString()}
                          </h2>
                          {card.sub && (
                            <small style={{ color: "#8a8d93" }}>
                              {card.sub}
                            </small>
                          )}
                        </div>
                        <div
                          style={{
                            width: "52px",
                            height: "52px",
                            borderRadius: "50%",
                            background: card.iconBg + "1a",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className={card.icon}
                            style={{ fontSize: "22px", color: card.iconBg }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          borderTop: "1px solid #f0f0f0",
                          paddingTop: "12px",
                        }}
                      >
                        <Link
                          to={card.link}
                          style={{
                            fontSize: "13px",
                            color: card.iconBg,
                            textDecoration: "none",
                            fontWeight: "500",
                          }}
                        >
                          {card.linkLabel}{" "}
                          <i
                            className="fa fa-arrow-right"
                            style={{ fontSize: "11px" }}
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ExpertDashboard;
